import { finish, error } from '../../../modules/bets/actions/settle';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

export function request(dispatch, { id, accountId }) {
    api.post(`/bets/${id}/unsettlement`, { accountId }).then(
        (data) => {
            if (data.maxBet) {
                data.maxBet = $appState.configState.precision.newFromOld(data.maxBet).value;
            }
            return dispatch(finish(id, data));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
